import Vue from 'vue';
import { ED_MODAL_EVENTS } from '@/plugins/ed-modal/ed-modal.plugin';
import Component from 'vue-class-component';
import { _HOMEWORKS_STORE, GRADING_SCALES, GRADING_EVENTS } from '@/homework/values/homeworks.values';
import { AUTH_EVENTS } from '@/auth/values/auth.values'
import EdInputModel from '@/models/ed-input.model';

@Component({})
export default class EdModalAgreementComponent extends Vue {

  /* Data */
  public saving: boolean = false;
  public acceptTerms: any = EdInputModel('acceptTerms', false, {}, true);
  public terms: any = {}

  /* Computed */
  get termsText() {
    return this.$i18n.locale == 'es' ? this.terms.bodySpanish : this.terms.bodyEnglish
  }

   /* Methods */
  confirm () {
    this.$edEventBus.$emit(AUTH_EVENTS.CONFIRM_TERMS_MODAL, this.terms.id);
    this.closeModal()
  }

  closeModal() {
    this.$EdModal.closeModal();
  }

  async created() {
    this.terms = await this.$Auth.Services.getTerms();
  }
}
